import styles from './FJImageExtenderGenerateNumber.module.less';
import ArrowIcon from '../../../../assets/svg/button-right.svg?react';
import FJSideModel from '../../../../common/components/FJSideModel/FJSideModel';
import { useState } from 'react';
import PropTypes from 'prop-types';
import FJTextToImageDataConfig from '../../../../config/dataConfig/FJTextToImageDataConfig';
import CheckIcon from '../../../../assets/svg/choose.svg?react';
import classNames from 'classnames';
import FJLocalStore from '../../../../store/FJLocalStore';

const FJImageExtenderGenerateNumber = ({ generateNumber, onChange }) => {
    const [showSideModel, setShowSideModel] = useState(false);

    const handleClick = e => {
        e.stopPropagation();
        setShowSideModel(!showSideModel);
    };

    const handleOnMouseDown = e => {
        showSideModel && e.stopPropagation();
    };

    const handleChangeGenerateNumber = value => {
        onChange && onChange(value);
        setShowSideModel(false);
    };

    return (
        <>
            <div className={styles.image_number_box}>
                <div className={styles.image_number_title}>{FJLocalStore._('quantity')}</div>
                <div className={styles.image_number_btu} onClick={handleClick} onMouseDown={handleOnMouseDown}>
                    {generateNumber}
                    <ArrowIcon className={styles.arrow_icon} />
                </div>
            </div>
            <FJSideModel
                position={{ top: 489, left: 478 }}
                active={showSideModel}
                className={styles.image_number_side_model}
                onClose={() => setShowSideModel(false)}
            >
                <div className={styles.model_image_number_title}>{FJLocalStore._('quantity')}</div>

                <div className={styles.image_number_list_box}>
                    {FJTextToImageDataConfig.IMAGE_NUMBER_LIST.map(item => {
                        return (
                            <div
                                className={classNames(
                                    styles.image_number_item,
                                    item.value == generateNumber && styles.image_number_item_active,
                                )}
                                key={item.value}
                                onClick={() => handleChangeGenerateNumber(item.value)}
                            >
                                <div className={styles.image_number_item_text}>{item.text}</div>
                                {item.value == generateNumber && <CheckIcon className={styles.check_icon} />}
                            </div>
                        );
                    })}
                </div>
            </FJSideModel>
        </>
    );
};

FJImageExtenderGenerateNumber.propTypes = {
    generateNumber: PropTypes.number,
    onChange: PropTypes.func,
};

export default FJImageExtenderGenerateNumber;
